import React, {PureComponent} from 'react';
import ResultViewer from './ResultViewer';
import {Collapse, Fade, LinearProgress, withStyles} from '@material-ui/core';
import ResponsePanelHeader from './ResponsePanelHeader';

const styles = {
    progressBar: {
        position: 'absolute',
        top: '51px',
        left: 0,
        right: 0,
        zIndex: 10
    }
};

class ResponsePanel extends PureComponent {
    state = {
        showProgress: false
    };

    componentDidUpdate(prevProps) {
        const isFetching = this.props.response && this.props.response.fetching;
        const wasFetching = prevProps.response && prevProps.response.fetching;
        if (isFetching !== wasFetching) {
            if (isFetching) {
                this._showProgressTimer = setTimeout(() => {
                    this.setState({
                        showProgress: true
                    });
                }, 200);
            } else {
                clearTimeout(this._showProgressTimer);
                this.setState({
                    showProgress: false
                });
            }
        }
    }

    render() {
        let content = null;
        let loadingCover = null;
        if (this.props.response) {
            const {fetching, body} = this.props.response;
            if (fetching) {
                loadingCover = (
                    <Fade in={true}>
                        <div className="loading-cover" />
                    </Fade>
                );
            }
            if (body) {
                content = (
                    <ResultViewer value={body}/>
                );
            }
        } else {
            const modifier = window.navigator.platform === 'MacIntel' ? '⌘ ' : 'Ctrl-';
            content = (
                <div className="overlay">
                    <div className="action-list">
                        <div className="action">
                            <div className="action-name">Send Request</div>
                            <div className="action-key">{modifier}Enter</div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="response-panel">
                <ResponsePanelHeader response={this.props.response}/>
                <Collapse
                    in={this.state.showProgress}
                    timeout={225}
                    classes={{
                        container: this.props.classes.progressBar
                    }}>
                    <LinearProgress variant="query" />
                </Collapse>
                {content}
                {loadingCover}
            </div>
        );
    };
}

export default withStyles(styles)(ResponsePanel);



// WEBPACK FOOTER //
// ./src/components/ResponsePanel.js